
import SvgIcon from "@/components/SvgIcon.vue";

// 2. 自动加载svg目录下所有图标
const req = require.context("./svg", false, /\.svg$/);
// 返回数组的名称就是图标文件的名称
req.keys().map(req);

// 3. 导出安装函数供主应用使用
export default {
  install(app) {
    // 注册svg-icon组件
    app.component("svg-icon", SvgIcon);
  }
};